import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { PatientLogin } from "@main/users";
import { MenuItem } from "primeng/api";

@Component({
    selector: "widget-action-menu",
    templateUrl: "./widget-action-menu.component.html"
})
export class WidgetActionMenuComponent {
    _widgetLinks: { id: string; name: string; url: string }[] = [];
    actions: MenuItem[];

    @Input() rowData: any;
    @Input() columnQueryAlias: string;
    @Input() patientData: PatientLogin;

    @Input() set widgetLinks(widgetLinks: { id: string; name: string; url: string }[]) {
        // Update just if the list is different.
        if (this._widgetLinks.length != widgetLinks.length ||
            this._widgetLinks.find((x, i) =>
                x.id != widgetLinks[i].id ||
                x.name != widgetLinks[i].name ||
                x.url != widgetLinks[i].url)
        ) {
            this._widgetLinks = widgetLinks;
            this.actions = this.generateActions();
        }
    }

    @Output() readonly menuOpened = new EventEmitter<any>();

    private patientService = inject(PatientService);
    private router = inject(Router);

    generateActions(): MenuItem[] {
        return this._widgetLinks.filter(a => a.name && a.url)
            .map(a => (
                {
                    id: this.columnQueryAlias,
                    label: a.name,
                    command: () => this.onActionClick(this.resolveUrl(a.url))
                })
            );
    }

    private resolveUrl(urlTemplate: string): string {
        if (!urlTemplate) return "";

        const resolvedUrl = urlTemplate.replace(/{([\w.]+)}/g, (_, field) => {
            const key = field.replace(/\./g, "_");
            return encodeURIComponent(this.rowData?.[key] ?? "");
        });

        return /^https?:\/\//i.test(resolvedUrl) ? resolvedUrl : `https://${resolvedUrl}`;
    }

    onActionClick(url: string) {
        const targetUrl = new URL(url);

        // Verify if the URL is inside MiPro or not
        const isAppURL = location.protocol === targetUrl.protocol && location.host === targetUrl.host;

        if (isAppURL) {
            if (this.patientData) {
                this.patientService.currentPatientPlaceHolder = {
                    id: this.patientData.patientId,
                    fullName: this.patientData.fullName
                };
            }

            // Convert the absolute URL produced by resolveUrl to an app-relative route.
            const baseUrl = window.location.origin;
            const relativeUrl = url.replace(baseUrl, "");

            this.router.navigateByUrl(relativeUrl);
        } else {
            window.location.href = url;
        }
    }

    onMenuOpened() {
        this.menuOpened.emit(this.rowData);
    }
}
